/*
 *   Copyright (c) 2021 Youra Leangseng
 *   All rights reserved.
 */
import common from '../action/commonActions'

export const initialState = ({
  isLoading: false,
  senders: null,
  drivers: null,
  provinces: null,
  users: null,
})

export default function (state = initialState, action) {
  switch (action.type) {

    case common.TYPES.REQUEST_SENDER_SUCCESS:
      return Object.assign({}, state, {
        senders: action.payload,
      });

    case common.TYPES.REQUEST_PROVINCE_SUCCESS:
      return Object.assign({}, state, {
        provinces: action.payload
      })

    case common.TYPES.REQUEST_SENDER_FAILED:
      return Object.assign({}, state, { senders: null })

    // driver
    case common.TYPES.REQUEST_DRIVER_SUCCESS:
      return Object.assign({}, state, {
        drivers: action.payload
      })

    case common.TYPES.REQUEST_ACTIVE_USER_SUCCESS:
    return Object.assign({}, state, {
      users: action.payload
    })
    default:
      return state
  }
}
